import { MAX_FILE_SIZE_MB, MAX_DURATION_LABEL } from './constants';

const texts = {
  title: 'Create Exercises from Videos',
  batchChip: '{count} in this batch',
  introAutoSave: 'Upload a batch of demo clips and we’ll turn each one into an exercise. Verify the '
    + 'auto-filled name — a description and tags are optional and can be added anytime — each '
    + 'exercise saves itself as soon as its video upload finishes.',
  introManual: 'Upload a batch of demo clips and we’ll turn each one into an exercise. Verify the '
    + 'auto-filled name — a description and tags are optional and can be added anytime — then save '
    + 'each card once its upload succeeds, or save them all at once.',

  // Auto-save
  autoSaveTitle: 'Auto-save exercises when ready',
  autoSaveOn: 'ON',
  autoSaveOff: 'OFF',
  autoSaveDescription: 'When enabled, each exercise is created as soon as its video finishes uploading, using the '
    + 'auto-filled name. Otherwise, each card needs to be saved manually.',

  // Drop zone
  dropTitle: 'Drag videos here, or click to select',
  dropSubtitle: 'Each video becomes a new exercise. Drop as many as you like — they upload in the background.',
  dropTitleSlim: 'Drop more videos to add exercises',
  dropSubtitleSlim: 'New cards append below',
  selectVideos: 'Select videos',
  constraints: [
    `Under ${MAX_FILE_SIZE_MB}MB`,
    '9:16 portrait',
    `Up to ${MAX_DURATION_LABEL}`,
    'mp4 (audio ok)',
  ],
  emptyNote: 'Your dropped videos will appear here as exercise cards.',

  // Card fields
  videoLabel: 'Exercise Video',
  nameLabel: 'Exercise Name',
  descriptionLabel: 'Exercise Description',
  tagsLabel: 'Tags',
  namePlaceholder: 'e.g. Barbell Back Squat',
  descriptionPlaceholder: 'Coaching cues, setup, tempo…',
  untitled: 'Untitled exercise',
  defaultCardName: 'Exercise {number}',
  nameExistsError: 'An exercise named “{name}” already exists',
  duplicateNameError: 'Duplicate name in this batch',

  // Card statuses / badges
  queuedBadge: 'Queued',
  uploadingBadge: 'Uploading {progress}%',
  readyBadge: 'Ready to save',
  uploadFailedBadge: 'Upload failed',
  savingBadge: 'Saving…',
  saveFailedBadge: 'Save failed',
  savedBadge: 'Saved',
  needName: 'Needs a name',
  fixName: 'Fix name',
  incomplete: 'Incomplete',

  // Card video block
  noVideo: 'No video',
  noVideoNote: 'This exercise will be saved without a demo video.',
  addVideo: 'Add a video',
  removeVideo: 'Remove video',
  retryUpload: 'Retry upload',
  chooseDifferentFile: 'Choose different file',
  chooseFile: 'Choose a file',
  queuedNote: 'Waiting for an upload slot…',
  uploadTimeLeft: '~{time} left',
  oversizeError: 'This video is over {max}MB. Choose a smaller file.',
  savedWithVideoNote: 'Video processing — appears in the library shortly',
  savedWithoutVideoNote: 'Saved without a video',

  // Card actions
  save: 'Save',
  update: 'Update',
  edit: 'Edit',
  remove: 'Remove',
  retrySave: 'Retry save',
  expand: 'Expand',
  collapse: 'Collapse',
  removeExercise: 'Remove exercise',

  // Footer
  emptySummary: 'No exercises yet — drop a video to begin.',
  summaryExercise: 'exercise',
  summaryExercises: 'exercises',
  summarySaved: '{count} saved',
  summaryReady: '{count} ready',
  summaryUploading: '{count} uploading',
  summaryNeed: '{count} needs details',
  summaryNeedPlural: '{count} need details',
  summaryUploadFailed: '{count} upload failed',
  summarySaveFailed: '{count} save failed',
  saveReady: 'Save Ready ({count})',
  retryFailed: 'Retry Failed ({count})',
  leave: 'Leave',
  cancel: 'Cancel',
  doneViewLibrary: 'Done · View library',

  // Leave modal
  leaveTitleUnsaved: 'Leave with unsaved exercises?',
  leaveTitleUploading: 'Leave while uploading?',
  leaveBodyUnsaved: 'You have {count} unsaved draft(s) on this page. Leaving now discards them.',
  leaveBodyUploading: '{count} video(s) still uploading. If you leave now the upload will be lost, '
    + 'and your unsaved drafts won’t be created.',
  stayOnPage: 'Stay on page',
  leaveAnyway: 'Leave anyway',

  // Remove modal
  removeTitle: 'Remove this exercise?',
  removeBody: '{label} and its video will be removed from this batch. Nothing has been saved yet, '
    + 'so this only affects this card.',
  keepIt: 'Keep it',

  // Navigation guard (router-level)
  navGuardMessage: 'You have unsaved exercises. Leaving will discard your drafts and any '
    + 'in-progress video uploads. Continue?',

  // Toasts
  toastVideosAdded: '{count} video(s) added',
  toastVideoRemoved: 'Video removed — this exercise will save without a video',
  toastExerciseRemoved: 'Exercise removed',
  toastSaved: '{name} created',
  toastUpdated: '{name} updated',
  toastSaveFailed: 'Couldn’t save “{name}”',
  toastBatchDiscarded: 'Left — batch discarded',
  toastInvalidFiles: '{count} file(s) skipped — only video files are supported',

  // Session recovery
  fileLostError: 'This video was lost when the page closed. Select or drop the same file again to retry.',
  toastSessionRestored: 'Previous session restored — drop the missing video files again to retry their uploads',

  // Video upload failure copy
  uploadFailedGeneric: 'Upload failed. Check your connection and retry.',
  saveFailedGeneric: 'Couldn’t save this exercise. The video is already uploaded, so retrying won’t re-upload it.',
};

export default texts;
